class DcHeader extends HTMLElement {
  connectedCallback() {
    this.header = this.querySelector('[data-header]') || this;
    this.mobileMenu = this.querySelector('[data-mobile-menu]');
    this.menuToggle = this.querySelector('[data-menu-toggle]');
    this.closeButtons = this.querySelectorAll('[data-menu-close]');
    this.transparent = this.dataset.transparent === 'true';

    this.menuToggle?.addEventListener('click', this.openMenu);
    this.closeButtons.forEach((button) => button.addEventListener('click', this.closeMenu));
    this.addEventListener('keydown', this.handleKeydown);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    const scrolled = window.scrollY > 12;
    this.header.classList.toggle('is-scrolled', scrolled);
    this.header.classList.toggle('is-transparent', this.transparent && !scrolled);
  };

  openMenu = () => {
    if (!this.mobileMenu) return;
    this.mobileMenu.hidden = false;
    this.mobileMenu.classList.add('is-open');
    this.menuToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('overflow-hidden');
    this.mobileMenu.querySelector('button, a, summary')?.focus();
  };

  closeMenu = () => {
    if (!this.mobileMenu) return;
    this.mobileMenu.classList.remove('is-open');
    this.mobileMenu.hidden = true;
    this.menuToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('overflow-hidden');
    this.menuToggle?.focus();
  };

  handleKeydown = (event) => {
    if (event.key === 'Escape' && this.mobileMenu?.classList.contains('is-open')) this.closeMenu();
  };
}

if (!customElements.get('dc-header')) customElements.define('dc-header', DcHeader);
